/*@flow*/
import * as t from 'lib/t';
import enumList from '../util/enumList';
import Section from './templates/Section';
import CheckboxGroup from './templates/CheckboxGroup';
import RangeTemplate from './templates/RangeTemplate';
import TagsTemplate from './templates/Tags';
import isEmbedded from 'lib/isEmbedded';
import StatusesTemplate from './templates/Statuses';

const RangeType = t.struct({
  min: t.Number,
  max: t.Number,
});

const config = {
  status: t.list(t.String).opt({
    label: 'Status',
    template: StatusesTemplate,
    filterName: 'developments',
  }),
  propertyType: t.enums.of(enumList.propertyType).opt({
    template: CheckboxGroup,
    nullOption: false,
  }),
  developmentType: t.enums.of(enumList.developmentType).opt({
    template: CheckboxGroup,
    nullOption: false,
  }),
  ownershipType: t.enums.of(enumList.ownershipType).opt({
    template: CheckboxGroup,
    nullOption: false,
  }),
  newBuiltFloorArea: RangeType.opt({
    min: 0,
    max: 2000000000,
    template: RangeTemplate,
    label: 'New Built Floor Area (sq ft)',
  }),
  unitsMultiFamily: RangeType.opt({
    min: 0,
    max: 2000000000,
    template: RangeTemplate,
    label: 'Units',
  }),
  lotSize: RangeType.opt({
    min: 0,
    max: 2000000000,
    template: RangeTemplate,
    label: 'Lot Size (Units In Square Feet)',
  }),
  completion: RangeType.opt({
    min: 0,
    max: 3000,
    template: RangeTemplate,
    label: 'Completion Year',
  }),
  tags: t.list(t.String).opt({
    label: 'Tags',
    template: TagsTemplate,
    filterName: 'developments',
    hideWhen: isEmbedded,
  }),
};

export default t.struct(config).opt<any>({
  label: 'Development Activity',
  iconClass: 'fa-truck',
  template: Section,
});
